import { FormlyFieldConfig } from '@ngx-formly/core';
import { ConversionStatistics, ConversionWarning } from '@nx-ahs/formly/shared';
import { TripettoNode } from './tripetto-interfaces';

/**
 * Calculate conversion statistics from conversion results
 */
export function calculateStatistics(
	formlyFields: FormlyFieldConfig[],
	warnings: ConversionWarning[],
	unconverted: TripettoNode[],
	totalNodes: number,
	totalBranches: number
): ConversionStatistics {
	const hiddenFields = formlyFields.filter((f) => f.type === 'mat-formly-hidden').length;
	const nodesWithWarnings = warnings.filter((w) => w.severity === 'warning' || w.severity === 'error').length;

	return {
		totalNodes,
		convertedNodes: formlyFields.length,
		skippedNodes: unconverted.length,
		nodesWithWarnings,
		complexBranches: totalBranches,
		hiddenFields
	};
}
